export const PUBLIC_EVENT_KEY = 'pimster';
export const PUBLIC_EVENT_ERROR_KEY = '[Public Event Error]';
